module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.kmlOverlay) ? _c('div', {
    attrs: {
      "id": "outer"
    }
  }, [_c('div', {
    attrs: {
      "id": "message"
    }
  }, [_c('button', {
    staticClass: "small",
    attrs: {
      "id": "clearButton"
    },
    on: {
      "click": _vm.clearFeedback
    }
  }, [_vm._v(_vm._s(_vm.$t("kmlOverlay.clear")))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40ee86a1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KMLOverlay.vue
// module id = 631
// module chunks = 2